interface VerifiedBadgeBannerProps {
  kind: 'fully' | 'org' | 'verified';
  companyName: string;
  compact?: boolean;
  onEdit?: () => void;
}

// 검증 출처를 색으로 가른다: 국세청 검증 = brand / 우리 조직 등록 = emerald.
// 두 계열이 함께 뜨는 화면이라 한쪽만 옮기면 구분이 무너지므로, brand로 옮기되 emerald는 그대로 둔다.
const CONFIG = {
  fully: {
    bg: 'bg-brand-50',
    border: 'border-brand-200',
    iconColor: 'text-brand-600',
    textColor: 'text-brand-900',
    message: '검증 완료된 사업자입니다',
    trailingBadge: {
      className: 'ml-auto text-xs px-2 py-0.5 bg-brand-100 text-brand-800 rounded flex-shrink-0',
      label: '국세청 검증',
    },
    editButtonClass: null,
  },
  org: {
    bg: 'bg-emerald-50',
    border: 'border-emerald-200',
    iconColor: 'text-emerald-600',
    textColor: 'text-emerald-900',
    message: '우리 조직에 등록된 사업자 정보',
    trailingBadge: null,
    editButtonClass:
      'ml-auto text-xs text-emerald-700 underline hover:text-emerald-900 flex-shrink-0',
    editLabel: '수정',
  },
  verified: {
    bg: 'bg-brand-50',
    border: 'border-brand-200',
    iconColor: 'text-brand-600',
    textColor: 'text-brand-900',
    message: '사업자 정보 검증 완료',
    trailingBadge: null,
    editButtonClass:
      'ml-auto text-xs text-brand-700 underline hover:text-brand-900 flex-shrink-0',
    editLabel: '재검증',
  },
} as const;

export function VerifiedBadgeBanner({
  kind,
  companyName,
  compact = false,
  onEdit,
}: VerifiedBadgeBannerProps) {
  const config = CONFIG[kind];
  const iconSize = compact ? 'h-4 w-4' : 'h-5 w-5';

  return (
    <div
      className={`flex items-center gap-2 p-3 ${config.bg} border ${config.border} rounded-card`}
    >
      <svg
        className={`${iconSize} ${config.iconColor} flex-shrink-0`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          clipRule="evenodd"
        />
      </svg>
      <span className={`text-sm ${config.textColor} min-w-0 truncate`}>
        <span className="font-medium">{companyName}</span> {config.message}
      </span>
      {config.trailingBadge ? (
        <span className={config.trailingBadge.className}>
          {config.trailingBadge.label}
        </span>
      ) : (
        onEdit && (
          <button
            type="button"
            onClick={onEdit}
            className={config.editButtonClass ?? ''}
          >
            {'editLabel' in config ? config.editLabel : ''}
          </button>
        )
      )}
    </div>
  );
}
